<template>
    <div class="cs-offerwall__filters" v-if="!!filters">
        <OfferWallFilterComponent :isMultiselect="isFilterMultiselect.social" :filter="filters.social" 
        :title="dictionary.filterCategories.social"
        :selectedFilters="selectedFilters.social"
        @filterClick="onOfferWallFilterComponentClick('social')">
        </OfferWallFilterComponent>
        <OfferWallFilterComponent :isMultiselect="isFilterMultiselect.category" :filter="filters.category" 
        :title="dictionary.filterCategories.category"
        :selectedFilters="selectedFilters.category"
        @filterClick="onOfferWallFilterComponentClick('category')">
        </OfferWallFilterComponent>
        <OfferWallFilterComponent :filter="filters.status" :title="dictionary.filterCategories.status"
        :selectedFilters="selectedFilters.status"  
        @filterClick="onOfferWallFilterComponentClick('status')">
        </OfferWallFilterComponent>
        <OfferWallFilterComponent :filter="filters.discount" :title="dictionary.filterCategories.discount"
        :selectedFilters="selectedFilters.discount"  
        @filterClick="onOfferWallFilterComponentClick('discount')">
        </OfferWallFilterComponent>
        <OfferWallFilterOptionsComponent :filterOptions="filterOptions" :dictionary="filterDictionary" 
        :showFilterOptions="showFilterOptions" :isMultiselect="isFilterMultiselect[selectedFilterName]"
        :selectedFilters="selectedFilters[selectedFilterName]"
        @closeFilterOptionsComponent="onCloseFilterOptions()"
        @reset-filters="resetSelectedFilter()"
        @clickedFilterOptions="addOrRemoveFilterOption"
        >
        </OfferWallFilterOptionsComponent>
    </div>
</template>

<script>
import OfferWallFilterComponent from "./OfferWallFilterComponent.vue";
import OfferWallFilterOptionsComponent from "./OfferWallFilterOptionsComponent.vue";
export default {
    name: 'OfferWallFiltersComponent',
    components: {
        OfferWallFilterComponent,
        OfferWallFilterOptionsComponent
    },
    props: [
        "filters", "dictionary"
    ],
    emits:['updateFilters'],
    data: function(){
        return{
            showFilterOptions: false,
            filterOptions: null,
            filterDictionary: null,
            selectedFilterName: '',
            selectedFilters: {
                social: [],
                category: [],
                status: [],
                discount: []
            },
            isFilterMultiselect: {
                social: true,
                category: true,
                status: false,
                discount: false
            }
        }
    },
    methods: {
        onOfferWallFilterComponentClick(filterName){
            this.filterOptions = this.filters[filterName];
            this.filterDictionary = this.dictionary.filterCategoriesOptions[filterName];
            this.selectedFilterName = filterName;
            this.toggleShowFilterOptions();
        },
        toggleShowFilterOptions(){
            this.showFilterOptions = !this.showFilterOptions;
        },
        resetSelectedFilter(){
            this.selectedFilters[this.selectedFilterName] = [];
        },
        addOrRemoveFilterOption(option, isMultiselect){
            if(isMultiselect) {
                if(this.selectedFilters[this.selectedFilterName].includes(option)){
                    this.selectedFilters[this.selectedFilterName].splice(this.selectedFilters[this.selectedFilterName].indexOf(option),1);
                }else{
                    this.selectedFilters[this.selectedFilterName].push(option);
                }
            } else {
                this.selectedFilters[this.selectedFilterName] = [option];
                setTimeout(() => {
                    this.onCloseFilterOptions();
                }, 200);
            }
        },
        onCloseFilterOptions(){
            this.toggleShowFilterOptions();
            this.$emit('updateFilters', this.selectedFilters);
        }
    },
    mounted: function() {
    }
}
</script>

<style lang="scss" scoped>
    .cs-offerwall__filters{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto 20px auto;
        overflow-x: scroll ;
        max-width: 600px;
        cursor: grab;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */

        &::-webkit-scrollbar {
            display: none;
        }
    }
</style>